export enum TraverseMode
{
	BreadthFirst = 0,
	DepthFirst = 1
}